// Core
import React from "react";

// Styles
import "./styles.scss";

const NormalTabs = (props) => {
  const { tabs, activeTab, handleTab } = props;

  return (
    <div className="tab-container d-flex px-4 gap-5">
      {tabs.map((tab, index) => {
        return (
          <p
            key={tab}
            className={activeTab === index ? "activeTabs" : "tab"}
            onClick={() => handleTab(index)}
          >
            {tab}
          </p>
        );
      })}
    </div>
  );
};

export default NormalTabs;
